const o = (t) => {
  const e = document.getElementById(t);
  if (e)
    for (; e.lastChild; )
      e.lastChild.remove();
};
export {
  o as removeGoogleReCaptchaContainer
};
//# sourceMappingURL=removeGoogleReCaptchaContainer.js.map
